import { render, staticRenderFns } from "./NlDuration.vue?vue&type=template&id=595c7e2e&scoped=true&"
import script from "./NlDuration.vue?vue&type=script&lang=js&"
export * from "./NlDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595c7e2e",
  null
  
)

export default component.exports